export default "__VITE_ASSET__keNi7cWD__"